<template>
	<v-container fluid pa-0 mx-2 style="width: auto;"
		:style="menuOpen ? 'z-index: 999;':''">
		<v-menu
			v-model="menuOpen"
			bottom
			offset-y
			left
			min-width="550"
			max-width="550"
			content-class="container-notification-menu-header"
			:close-on-content-click="false"
			@input="changeMenu"
		>
			<template v-slot:activator="{ on, attrs }">
				<v-badge
					:color="$store.state.notifications.badgeColor"
					:content="$store.state.notifications.badgeText"
					:value="showBadge"
					overlap
				>
					<v-btn
						fab
						dark
						class="button-activator-notifications"
						:small="size === 'small'"
						:x-small="size === 'x-small'"
						:loading="$store.state.notifications.loadingNotifications"
						color="#524D4D"
						v-bind="attrs"
						v-on="on"
						@click="clearTray"
					>
						<v-icon dark>mdi-bell-outline</v-icon>
					</v-btn>
				</v-badge>
			</template>
			<div class="d-flex flex-row align-center justify-space-between">
				<div class="d-flex flex-row px-4" style="border-left: 2px solid #524D4D;">
					<v-icon dark color="#524D4D" class="mr-5">mdi-bell-outline</v-icon>
					<p class="mb-0 font-weight-bold" style="color: #524D4D">Notificaciones</p>
				</div>
				<div>
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn icon color="grey" class="mr-3"
										v-bind="attrs"
										v-on="on"
										@click="markAllNotificationsAsRead">
								<v-icon>mdi-email-open-multiple-outline</v-icon>
							</v-btn>
						</template>
						<span>Marcar todo como visto</span>
					</v-tooltip>
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn icon color="grey" class="mr-3"
										v-bind="attrs"
										v-on="on"
										@click="reloadNotifications()">
								<v-icon>mdi-cached</v-icon>
							</v-btn>
						</template>
						<span>Recargar notifications</span>
					</v-tooltip>
				</div>
			</div>
			<v-divider class="mx-2"></v-divider>
			<div v-if="$store.state.notifications.notifications.length > 0">
				<v-list style="max-height: 75vh;overflow: scroll;">
					<v-list-item
						v-for="(item, i) in $store.state.notifications.notifications"
						:key="i"
						class="px-0 py-0"
						@click="viewItem(item, i)"
					>
						<div style="width: 100%">
						<div class="d-flex flex-row px-4 pt-2 justify-space-between" style="gap: 12px;">
							<div class="d-flex flex-row" style="flex: 1; min-width: 0;">
								<img v-if="getNotificationImage(item)"
									:src="getNotificationImage(item)" class="notification-img"/>
								<v-icon v-else class="notification-img icon" color="#524D4D" >mdi-account</v-icon>
								<div class="px-4 caption" style="flex: 1; min-width: 0;">
									<small class="mb-0" style="color: #707070;">Proyecto: <b>{{ getNotificationTitleInfo(item) }}</b></small>
									<p class="mb-0 caption font-weight-bold" style="color: #707070; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 0;">{{ item.title }}</p>
									<div class="mb-0 caption notification-description" style="color: #707070;" v-html="item.description">{{ item.description }}</div>
								</div>
							</div>
							<div class="d-flex flex-column align-center" style="flex-shrink: 0;">
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<v-btn icon
												@click.stop="markNotificationAsRead(item.id, i)"
												v-bind="attrs"
												v-on="on">
												<v-icon
													small
													:color="item.readed || loadingIndexes.includes(i) ? 'grey lighten-2':'#FF120B'"
													>mdi-circle</v-icon>
											</v-btn>
										</template>
										<span>Marcar como vista</span>
									</v-tooltip>
									<div style="min-width: 50px;">
										<p class="text-center mb-0" style="color: #707070;font-size: 10px;">{{ item.created_at | toDate }}</p>
										<p class="text-center mb-0" style="color: #707070;font-size: 10px;">{{ item.created_at | toHour }}</p>
									</div>
								</div>
							</div>
							<v-divider class="mt-2 mx-2"></v-divider>
						</div>
					</v-list-item>
					<div class="mt-3 mx-4">
						<v-btn
							depressed
							color="#524D4D"
							:dark="$store.state.notifications.notifications.length >= 10"
							block
							small
							:loading="$store.state.notifications.loadingNotifications"
							:disabled="$store.state.notifications.notifications.length < 10"
							@click="reloadNotifications(10)"
						>
							<v-icon small>mdi-email-outline</v-icon>
							<p class="mb-0 ml-2 caption">Ver antiguas</p>
						</v-btn>
					</div>
				</v-list>
			</div>
			<div v-else class="d-flex flex-column align-center justify-center">
				<v-icon class="mt-3 mb-2" large>mdi-check-circle-outline</v-icon>
				<p class="body-2">No hay notificaciones nuevas</p>
			</div>
		</v-menu>
	</v-container>
</template>

<script>
import { eventBus } from '@/components/Helpers/Events/NotificationsEventBus'
import {markAsReaded} from '@/helpers/api/notifications'

export default {
	name: 'NotificationHeader',
	props: {
		size: {
			type: String,
			default: 'small'
		},
		clearTray: {
			type: Function,
			required: true
		}
	},
	components: {
	},
  computed: {
		showBadge(){
			return this.$store.state.notifications.hasRegularNotifications
			// return this.$store.state.notifications.badgeText !== '0' && this.$store.state.notifications.badgeText !== '--' && this.$store.state.notifications.hasRegularNotifications
		},
    loadingNotifications() {
      return this.$store.state.notifications.loadingNotifications
    },
		userInfo() {
			return this.$store.state.user.userInfo
		},
		selectedCompany(){
			return this.$store.state.companies.selectedCompany
		},
		isCompanyClient(){
			if(this.selectedCompany && this.userInfo){
				const company = this.userInfo.companies.find((company) => {
					return this.$store.state.companies.selectedCompany.id == company.id
				})
				return company?.role_id == 4
			}
			return false
		},
  },
  watch: {
    loadingNotifications(newData) {
      if(newData){
				this.reloading = true
      }
			else if(this.reloading){
				this.reloading = false
				this.loadingIndexes = []
				this.loadingTaskIndexes = []
				this.loadingRdiIndexes = []
			}
    }
  },
	data: () => ({
		reloading: false,
		loadingIndexes: [],
		loadingTaskIndexes: [],
		loadingRdiIndexes: [],
		menuOpen: false,
		maxNotifications: 10
	}),
	mounted(){
	},
	methods: {
		getPlProjectType(items){
			const hierarchy = {
				'App\\Models\\BotConversation': 1,
				'App\\Models\\PreProject': 2,
				'App\\Models\\Project': 3
			};
			const mostRelevant = items.reduce((highest, current) => {
				const currentLevel = hierarchy[current.morphable_type] || 0;
				const highestLevel = highest ? hierarchy[highest.morphable_type] || 0 : 0;

				return currentLevel > highestLevel ? current : highest;
			}, null);
			return mostRelevant;

		},
		getNotificationTitleInfo(item) {
			let name = ''
			let district = ''
			let client = ''
			if(item.item_type == 7){
				if(item.itemable?.project_line_id && item.itemable?.project_line_associations.length){
					const project = this.getPlProjectType(item.itemable.project_line_associations)
					name = project.morphable?.name || '--';
					district = project.morphable?.info?.address?.district?.name ?? project.morphable?.info?.address?.address ?? '--';
					if(district !== '--' && district.length > 30) {
						district = district.substring(0, 30) + '...';
					}
					
					const profile = project.morphable?.client?.profile;
					client = `${profile.name ?? ''} ${profile.lastname ?? ''} ${profile.second_lastname ?? ''}`.trim()
				}
				else{
					const profile = item.notifier_user?.profile;
					client = `${profile.name ?? ''} ${profile.lastname ?? ''} ${profile.second_lastname ?? ''}`.trim()
					return 'Nuevo Proyecto | ' + client
				}
			}
			else if(item.item_type <= 2 || item.item_type == 3 || item.item_type == 9 || item.item_type == 13){
				name = '[LP' + item.itemable?.project_line_info?.project_line?.number + '] ' + (item.itemable?.name || item.itemable?.info?.project_detail) ?? '';
				district = item.itemable?.info?.address?.district?.name ?? item.itemable?.info?.address?.address ?? '--';
				if(district !== '--' && district.length > 30) {
					district = district.substring(0, 30) + '...';
				}
				client = this.getClientName(item) ?? '';
			}
			else if(item.item_type == 8){
				name = '[LP' + item.itemable?.conceptable?.morphable?.project_line_info?.project_line?.number + '] ' + (item.itemable?.conceptable?.morphable?.name || item.itemable?.conceptable?.morphable?.info?.project_detail) ?? '';
				district = item.itemable?.conceptable?.morphable?.info?.address?.district?.name ?? item.itemable?.conceptable?.morphable?.info?.address?.address ?? '--';
				if(district !== '--' && district.length > 30) {
					district = district.substring(0, 30) + '...';
				}
				client = this.getClientName(item) ?? '';
			}
			else if(item.item_type == 12){
				name = '[LP' + item.itemable?.project?.project_line_info?.project_line?.number + '] ' + (item.itemable?.project?.name || item.itemable?.project?.info?.project_detail) ?? '';
				district = item.itemable?.project?.info?.address?.district?.name ?? item.itemable?.project?.info?.address?.address ?? '--';
				if(district !== '--' && district.length > 30) {
					district = district.substring(0, 30) + '...';
				}
				client = this.getClientName(item) ?? '';
			}
			else{
				name = '[LP' + item.itemable?.morphable?.project_line_info?.project_line?.number + '] ' + (item.itemable?.morphable?.name || item.itemable?.morphable?.info?.project_detail) ?? '';
				district = item.itemable?.morphable?.info?.address?.district?.name ?? item.itemable?.morphable?.info?.address?.address ?? '--';
				if(district !== '--' && district.length > 30) {
					district = district.substring(0, 30) + '...';
				}
				client = this.getClientName(item) ?? '';
			}
			return `${name} | ${district} | ${client}`;
		},
		getNotificationImage(item){
			if(item.notifier_user?.profile?.avatar){
				return item.notifier_user?.profile?.avatar
			}
			if(this.isCompanyClient){
				return item?.company?.logo
			}
			return item?.itemable?.morphable?.client?.profile?.avatar
		},
		getClientName(item){
			const client = item.itemable?.client || item.itemable?.morphable?.client || item.itemable?.project?.client || item.itemable?.conceptable?.morphable?.client;
			
			if(!client){
				return ''
			}

			if(client?.profile){
				const profile = client.profile;
				return `${profile.name ?? ''} ${profile.lastname ?? ''} ${profile.second_lastname ?? ''}`.trim()
			}
			
			const profile = item.itemable?.morphable?.user?.user?.profile;
			const fallbackUser = item.itemable?.morphable?.user;

			const name = profile
				? `${profile.name ?? ''} ${profile.lastname ?? ''} ${profile.second_lastname ?? ''}`.trim()
				: fallbackUser
				? `${fallbackUser.name ?? ''} ${fallbackUser.lastname ?? ''} ${fallbackUser.second_lastname ?? ''}`.trim()
				: 'No identificado';

			return name || 'No identificado';
		},
		reloadNotifications(add = null){
			if(add){
				this.maxNotifications += add
			}
			else{
				this.maxNotifications = 10
			}
			this.$store.dispatch('notifications/getNotifications', {take: this.maxNotifications, types: [1,2,5,6,7,8,9,10,11,12,13]})
		},
		async viewItem(item, index){
			item.item_type != 12 && this.$router.replace({ path: this.$router.currentRoute.path, query: {} })
			
			this.markNotificationAsRead(item.id, index)
			if(item.item_type == 1){
				// Nueva conversación
				eventBus.$emit('reloadInformation', {crm_id: item.item_id})

				if(item.data.panel_redirect_path){
					this.$router.push(item.data.panel_redirect_path)
				}
				else{
					this.$router.push({ name: 'Conversation', params: { id: item.item_id } })
				}
			}
			if(item.item_type == 2){
				// Agenda confirmada
				// if(item.data.is_payment_request){
				// 	let modal_content = `${'<p class="mb-0">Te han agendado una Visita Técnica. Esta visita tiene un costo asociado.</p><p class="mb-0 font-weight-bold">El monto es de $' + this.$options.filters.toThousandFilter(item.data.amount) + '.</p><p>Por favor confirma a continuación para realizar este pago.</p>'}`
				// 	let concept = 'Solicitud de Pago: ' + item.data.concept
				// 	if(!item.data.amount){
				// 		concept = 'Solicitud de Confirmación: ' + item.data.concept
				// 		modal_content = `${'<p>Te han agendado una Visita Técnica. Por favor confírmala a continuación.</p>'}`
				// 	}
				// 	const confirmationModal = {
				// 		title: concept,
				// 		is_payment_request: true,
				// 		redirect_payment_url: item.data.redirect_payment_url,
				// 		schedule_id: item.data.schedule_id,
				// 		to_pay_amount: item.data.amount,
				// 		modal_content,
				// 		status: true
				// 	}
				// 	this.$store.commit('general/setGeneralConfirmationModal', confirmationModal)
				// }

				if(item.data.panel_redirect_path){
					if (this.$route.fullPath === item.data.panel_redirect_path) {
						this.$router.go(0)
					} else {
						this.$router.push(item.data.panel_redirect_path)
					}
				}
				else{
					this.$router.push({ name: 'Conversation', params: { id: item.item_id } })
				}
			}
			if(item.item_type == 3){
				// Chat mensaje desde preproject
				if(this.selectedCompany.capabilities.view_preprojects){
					this.$router.push({ name: 'PreProject', params: { id: item.item_id } })
				}
				else{
					this.$router.push({ name: 'ClientDetail', query: { p: item.item_id } })
				}
				this.$store.commit('preprojects/setOpenChatModal', true)	
			}
			if(item.item_type == 4){
				// Nueva observación en contrato
				eventBus.$emit('reloadInformation', {contract_id: item.item_id})
				if(item.data && item.data.panel_redirect_path){
					// this.$router.push(item.data.panel_redirect_path)
					let finalPath = item.data.panel_redirect_path
					if(item.data.addendum_to_contract_id){
						if(item.data.panel_redirect_path.includes('client')){
							const url = new URL(finalPath, window.location.origin);
							url.searchParams.delete('ct');
							finalPath = url.pathname + url.search;
							this.$store.commit('contracts/setContractAddendumModalId', item.data.contract_id)
						}
						else{
							finalPath = finalPath.replace('contracts/detail', 'contracts/addendum_detail')
						}
					}
					this.$router.push(finalPath)
				}
				else{
					this.$router.push({ name: 'ContractDetail', query: { id: item.item_id } })
				}
			}
			if(item.item_type == 5){
				// Cambio en presupuesto
				eventBus.$emit('reloadInformation', {budget_id: item.item_id})
				if(item.data && item.data.panel_redirect_path){
					this.$router.push(item.data.panel_redirect_path)
				}
				else{
					this.$router.push({ name: 'Budgets', query: { b: item.item_id } })
				}
			}
			if(item.item_type == 6){
				// Cambio en informe
				eventBus.$emit('reloadInformation', {report_id: item.item_id})
				if(item.data && item.data.panel_redirect_path){
					this.$router.push(item.data.panel_redirect_path)
				}
				// else{
				// 	this.$router.push({ name: 'Reports', query: { b: item.item_id } })
				// }
			}
			if(item.item_type == 7){
				// Solicitud directa
				eventBus.$emit('reloadInformation', {user_request_id: item.user_request_id})
				if(item.data && item.data.panel_redirect_path){
					this.$router.push(item.data.panel_redirect_path)
				}
			}
			if(item.item_type == 8){
				// Pago Realizado
				eventBus.$emit('reloadInformation')
				if(item.data.is_payment_request){
					const modal_content = `${'<p class="mb-0">Te han enviado una solicitud de pago para tu proyecto.</p><p class="mb-0 font-weight-bold">El monto es de $' + this.$options.filters.toThousandFilter(item.data.amount) + '.</p><p>Por favor confirma a continuación para realizar este pago.</p>'}`
					const confirmationModal = {
						title: 'Solicitud de Pago: ' + item.data.concept,
						is_payment_request: true,
						redirect_payment_url: item.data.redirect_payment_url,
						modal_content,
						status: true
					}
					this.$store.commit('general/setGeneralConfirmationModal', confirmationModal)
				}
				else if(item.data && item.data.panel_redirect_path){
					this.$router.push(item.data.panel_redirect_path)
				}
			}
			if(item.item_type == 9 || item.item_type == 13){
				// Actualización en Preproyecto o Proyecto
				eventBus.$emit('reloadInformation')
				if(item.data && item.data.panel_redirect_path){
					this.$router.push(item.data.panel_redirect_path)
				}
			}
			if(item.item_type == 10){
				// Pago Desarchivo
				eventBus.$emit('reloadInformation')
				if(item.data && item.data.panel_redirect_path){
					this.$router.push(item.data.panel_redirect_path)
				}
			}
			if(item.item_type == 11){
				if(item.data && item.data.panel_redirect_path){
					this.$router.push(item.data.panel_redirect_path)
				}
			}
			if(item.item_type == 12){
				if(item.data?.additional_request_id){
					eventBus.$emit('reloadInformationAdditionalRequirement', {id: item.data.additional_request_id})
					this.$store.commit('projects/setAdditionalRequirementDetailModal', {
						additional_request_id: item.data.additional_request_id
					})
				}
				if(item.data?.contract_id){
					eventBus.$emit('reloadInformation', { contract_id: item.data.contract_id })
				}
			}
			this.changeMenu(false)
		},
		async markNotificationAsRead(notification_id, index){
				this.loadingIndexes.push(index)
				const tasks = await markAsReaded({id: notification_id})
				if(tasks.code == 200){
					this.reloadNotifications()
				}
		},
		async markAllNotificationsAsRead(){
			const notification_ids = this.$store.state.notifications.notifications.map((item) => {
				return item.id
			})
			if(notification_ids.length > 0){
				const tasks = await markAsReaded({ids: notification_ids})
				if(tasks.code == 200){
					this.reloadNotifications()
				}
			}
		},
		changeMenu(value){
			this.menuOpen = value
		}
	}
};
</script>

<style scoped>
	.container-notification-menu-header{
		background: white;
		margin-top: 10px;
		border-radius: 8px;
	}
	.notification-img{
		width: 40px;
		height: 40px;
		border-radius: 100%;
		object-fit: cover;
	}
	.notification-img.icon{
		background-color: #F0F2F8;
	}
	/deep/ .notification-description p{margin: 0;}
</style>
